import dayjs from 'dayjs';
import i18n from 'providers/Locale';
import {
	DAYS_OF_WEEK_FULL_I18N,
	DAYS_OF_WEEK_MINIMAL_I18N,
	MONTH_NAMES,
	MONTH_NAMES_I18N_MAP,
	WEEK_DAYS_FULL,
} from 'shared/time';
import Translation from 'types/Translation';

/**
 * Get humanized day label based on Date object.
 * Can be required as day of week (e.g. Monday, Thursday) if is not today or tomorrow
 * @return string;
 * */
const getByDate = (dateObject: Date, asDayOfWeek?: boolean): string => {
	const currentDate = dayjs(dateObject);
	const monthName = i18n(
		MONTH_NAMES_I18N_MAP[MONTH_NAMES[currentDate.month()]] as keyof Translation
	);
	if (currentDate.isToday()) {
		return i18n('today');
	}
	if (currentDate.isTomorrow()) {
		return i18n('tomorrow');
	}
	if (asDayOfWeek) {
		return getWeekDayName(dateObject);
	}

	return `${currentDate.get('date')} ${monthName}`;
};

/**
 * Get humanized day label based on day of week and location work status (today, tomorrow);
 * @return string;
 * */
const getByWeekDay = (dayOfWeek: number, status: string): string => {
	const nowDay = new Date().getDay();

	if (dayOfWeek === nowDay && status === 'today') {
		return i18n('today').toLocaleLowerCase();
	}

	return dayOfWeek - nowDay === 1
		? i18n('tomorrow').toLocaleLowerCase()
		: i18n(`day.full.${WEEK_DAYS_FULL[dayOfWeek]}` as keyof Translation);
};

const getWeekDayName = (date: Date) => {
	return i18n(DAYS_OF_WEEK_FULL_I18N[dayjs(date).day()] as keyof Translation);
};

const getMonthDayMinimal = (date: Date) => {
	return i18n(DAYS_OF_WEEK_MINIMAL_I18N[dayjs(date).month()] as keyof Translation, {
		day: dayjs(date).date().toString(),
	});
};

const dayLabel = {
	getByDate,
	getByWeekDay,
	getWeekDayName,
	getMonthDayMinimal,
};

export default dayLabel;
